import React from 'react';
import Button from '../../components/atoms/Button/Button';
import Container from '../../components/atoms/Container/Container';
import styles from './ReceiptUnconfirmed.module.scss';

interface Props {
  onContactSupport: () => void;
}

/**
 * CPAYMENT-1616: тикет ушёл оператору, но чек так и не приняли (исчерпаны попытки перезаливки
 * либо не дождались ответа проверки). Экран успеха здесь врёт, а обычная кнопка «вернуться» не
 * объясняет клиенту, что делать — поэтому явный призыв обратиться в поддержку.
 *
 * Текст нейтральный: никакой автоматизации, причин проверки и внутренних кодов.
 */
const ReceiptUnconfirmed: React.FC<Props> = ({ onContactSupport }) => (
  <section className={styles.wrapper}>
    <Container>
      <h3 className={styles.title}>Не удалось распознать чек</h3>
      <p className={styles.text}>
        Мы получили ваш документ, но не смогли подтвердить по нему оплату. Платёж проверит
        специалист — чтобы ускорить подтверждение, обратитесь в поддержку.
      </p>
      <Button
        onClick={onContactSupport}
        variant='primary'
        dataSentryElement='support'
      >
        Обратиться в поддержку
      </Button>
    </Container>
  </section>
);

export default ReceiptUnconfirmed;
